<template>
  <div>
    <mt-header title="使用指南">
      <router-link to="/" slot="left">返回</router-link>
    </mt-header>
    <p class="top-title">本预约系统只要针对有坐席的智能设备进行预约体验，在预约前请仔细阅读以下内容，祝您体验愉快。</p>
    <div class="guide-wrap">
      <div class="info-wrap">
        <p class="title">第一步</p>
        <div class="info">
          <p class="info-text">点击首页“预约体验”进行预约，并绑定手机号进行登录，建议使用您的真实姓名。</p>
          <div class="info-img">
            <div class="img-wrap">
              <img :src="space2" alt />
            </div>
            <div class="img-wrap">
              <img :src="space3" alt />
            </div>
          </div>
        </div>
      </div>

      <div class="info-wrap">
        <p class="title">第二步</p>
        <div class="info">
          <p class="info-text">根据您的需求选择体验的设备（座位）和日期时间。</p>
          <div class="info-img">
            <div class="img-wrap">
              <img :src="space4" alt />
            </div>
            <div class="img-wrap">
              <img :src="space5" alt />
            </div>
          </div>
        </div>
      </div>

      <div class="info-wrap">
        <p class="title">第三步</p>
        <div class="info">
          <p class="info-text">
            请提前到场，并根据设备序号进行扫码解锁，
            <span style="color: red">若您迟到时间超过10分钟，该设备将自动解锁并提供给 所有读者使用</span>，您的预约信息将作废，请重新预约。
          </p>
          <div style="width:100%;height:4rem">
            <img style="width:100%;height:100%" :src="space6" alt />
          </div>
        </div>
      </div>

      <div class="info-wrap">
        <p class="title">第四步</p>
        <div class="info">
          <p
            class="info-text"
          >若您有延长使用的需求，请在微信“我的预约”中进行延期，若无法延期则说明该设备已被其他人预约，请根据时间礼让下一位读者使用，您可以重新预约其他设备（座位）。</p>
          <div class="info-img">
            <div class="img-wrap">
              <img :src="space8" alt />
            </div>
            <div class="img-wrap">
              <img :src="space9" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import space1 from "../assets/img/space/space1.jpg";
import space2 from "../assets/img/space/space2.jpg";
import space3 from "../assets/img/space/space3.jpg";
import space4 from "../assets/img/space/space4.jpg";
import space5 from "../assets/img/space/space5.jpg";
import space6 from "../assets/img/space/space6.jpg";
import space8 from "../assets/img/space/space8.jpg";
import space9 from "../assets/img/space/space9.jpg";
export default {
  data() {
    return {
      space1,
      space2,
      space3,
      space4,
      space5,
      space6,
      space8,
      space9,
    };
  },
};
</script>
<style lang="less" scoped>
.top-title {
  padding: .35rem;
  font-size: 18px;
  text-indent: 0.7rem;
  line-height: 40px;
  text-align: justify;
}
.info-wrap {
  padding: 0 20px;
  width: 100%;
  margin-top: 20px;
  .title {
    text-align: left;
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc;
    font-size: 0.45rem;
    font-weight: 600;
  }
  .info {
    margin-top: 20px;
    .info-text {
      font-size: 0.35rem;
      text-indent: 0.7rem;
      line-height: 40px;
    }
    .info-img {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      .img-wrap {
        width: 48%;
        height: 220px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
.guide-wrap {
  width: 100%;
  padding: 20px;
}
.head-img {
  width: 100vw;
  height: 380px;
  img {
    width: 100%;
    height: 100%;
  }
}
.space-wrap {
  padding: 20px;
  .space-title {
    display: flex;
    margin-top: 40px;
    align-items: center;
  }
  .space-content {
    font-size: 0.4rem;
    margin-top: 40px;
    line-height: 0.7rem;
    color: #aaa;
  }
  .space-img {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    .img-wrap {
      width: 48%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.point {
  width: 10px;
  height: 30px;
  background-color: #006feb;
  margin-right: 20px;
}
.title {
  font-size: 0.4rem;
  font-weight: 700;
}
</style>